import * as React from 'react'
import { I18nService } from '../../../../services/utils/i18n.service'
import { castingStoreAvailableCustomerPlanSubscriptions, StoreProps } from '../../../../services/stores/casting.store'
import CastingCustomerPlansComponent from './casting-customer-plans.component'
import CastingCustomerPlanSubscriptionsComponent from './casting-customer-plan-subscriptions.component'
import CastingPendingCustomerPlanSubscriptionComponent from './casting-pending-customer-plan-subscription.component'
import { FloatingContainerTitle } from '../casting-styled.component'

const i18nScoped = new I18nService(require('./casting-customer-plan-picker.component.yml'))

export default function CastingCustomerPlanPickerComponent ({ store, data, data: { offeredService, customer, customerPlanSubscriptionRemovePendingId } }: StoreProps) {
  const availableCustomerPlanSubscriptions = React.useMemo(() => castingStoreAvailableCustomerPlanSubscriptions({ customer, offeredService }), [customer, offeredService])

  if (availableCustomerPlanSubscriptions.some(_ => !_.validated_at && _.id != customerPlanSubscriptionRemovePendingId)) {
    // the customer can continue with this draft subscription, cancel it or change the plan
    return <>
      <FloatingContainerTitle>{ i18nScoped.t('pending_subscription') }</FloatingContainerTitle>
      <CastingPendingCustomerPlanSubscriptionComponent store={ store } data={ data } />
    </>
  }

  if (availableCustomerPlanSubscriptions?.some(_ => _.validated_at)) {
    // the summary of the subscription (especially the usage) is displayed
    return <>
      <FloatingContainerTitle style={{ marginBottom: 0 }}>{ i18nScoped.t('my_subscriptions') }</FloatingContainerTitle>
      <CastingCustomerPlanSubscriptionsComponent store={ store } data={ data } />
    </>
  }

  // the customer can buy a new customer plan
  return <>
    <FloatingContainerTitle>{ i18nScoped.t('buyable_plans') }</FloatingContainerTitle>
    <CastingCustomerPlansComponent store={ store } data={ data } />
  </>
}
